import React from 'react';
import { MessageCircle } from 'lucide-react';

const SupportScreen = () => (
  <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-slate-900 p-4">
    <div className="max-w-md mx-auto pt-20">
      <div className="bg-gradient-to-br from-gray-800 to-gray-900 rounded-3xl shadow-2xl p-8 border border-gray-700">
        <div className="text-center mb-6">
          <div className="inline-block bg-indigo-900/50 rounded-full p-4 mb-4 border border-indigo-700/50">
            <MessageCircle className="w-8 h-8 text-indigo-400" />
          </div>
          <h2 className="text-2xl font-bold text-white mb-2">Поддержка</h2>
          <p className="text-gray-400">Мы всегда на связи</p>
        </div>

        <div className="space-y-4">
          <div className="bg-gradient-to-r from-indigo-900/30 to-purple-900/30 rounded-2xl p-6 border border-indigo-800/30">
            <h3 className="font-semibold text-white mb-2">Telegram</h3>
            <p className="text-indigo-400 font-semibold">@kit8exchange</p>
          </div>

          <div className="bg-gradient-to-r from-indigo-900/30 to-purple-900/30 rounded-2xl p-6 border border-indigo-800/30">
            <h3 className="font-semibold text-white mb-2">Время работы</h3>
            <p className="text-gray-400">Ежедневно, 24/7</p>
          </div>

          <div className="bg-gradient-to-r from-indigo-900/30 to-purple-900/30 rounded-2xl p-6 border border-indigo-800/30">
            <h3 className="font-semibold text-white mb-2">Среднее время ответа</h3>
            <p className="text-gray-400">5-10 минут</p>
          </div>
        </div>

        <button
          onClick={() => window.open('https://t.me/kit8exchange', '_blank')}
          className="w-full mt-6 bg-gradient-to-r from-indigo-600 to-purple-600 text-white rounded-xl py-4 font-semibold shadow-lg hover:shadow-xl hover:from-indigo-500 hover:to-purple-500 transition-all"
        >
          Открыть чат поддержки
        </button>
      </div>
    </div>
  </div>
);

export default SupportScreen;

